import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

import CartIcon from './CartIcon'
import LanguageSelector from './LanguageSelector'
import Logo from './Logo'
import { AuthContext } from '../../contexts/AuthContext'
import { HOME_PATH, LOGIN_PATH } from '../../config/routes'

const SiteHeader = () => {
  const { isLoggedIn, handleLogout } = useContext(AuthContext)

  const logout = () => {
    handleLogout()
  }

  return (
    <header>
      {/* Top bar */}
      <div className="container-fluid top-bar py-2">
        <div className="row">
          <div className="col-8 d-flex align-items-center">
            <Link to={HOME_PATH} className="btn-link ms-2">
              www.revesdebarousse.fr
            </Link>
          </div>
          <div className="col-4 d-flex justify-content-end align-items-center">
            <CartIcon />
            <LanguageSelector />
            <div
              className="login-icon-container"
              style={{ position: 'relative', marginLeft: '10px' }}
            >
              {isLoggedIn ? (
                <FontAwesomeIcon
                  icon={faSignOutAlt}
                  style={{ cursor: 'pointer', opacity: 1, color: 'inherit' }}
                  onClick={logout}
                />
              ) : (
                <Link to={LOGIN_PATH} style={{ color: 'inherit', opacity: 1 }}>
                  <FontAwesomeIcon
                    icon={faSignInAlt}
                    style={{ cursor: 'pointer', opacity: 1 }}
                  />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default SiteHeader
